import client from '@/http'

const load = (context, valueIds) => {
  client.get(
    `/values/${valueIds}`
  ).then(
    (res) => {
      context.commit('SET_VALUES', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const loadAll = (context, params) => {
  client.get(
    `/values/bundle/${params.bundleId}/column/${params.columnId}`
  ).then(
    (res) => {
      context.commit('SET_VALUES', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const loadQuestions = (context, params) => {
  let url = `/values/filter/questions/${params.nr}`

  if (params.admin) url += '/defaults'

  client.get(
    url
  ).then(
    (res) => {
      context.commit('SET_QUESTIONS', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const create = (context, params) => {
  client.post(
    'values', params
  ).then(
    (res) => {
      context.commit((params.mode === 'questions') ? 'PUSH_QUESTION' : 'PUSH', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const save = (context, params) => {
  client.put(
    'values', params
  ).then(
    () => {
      context.commit((params.mode === 'questions') ? 'UPDATE_QUESTION' : 'UPDATE', params)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const remove = (context, params) => {
  client.delete(
    `/values/${params.values}`
  ).then(
    () => {
      if ((params.mode === 'questions')) {
        context.commit('REMOVE_QUESTION', params.index)
      } else {
        params.values.forEach((valueId) => {
          context.commit('REMOVE', valueId)
        })
      }
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const copy = (context, params) => {
  client.put(
    'values/import',
    params
  ).then(
    () => {
      context.commit('COPY', params)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const sync = (context, params) => {
  client.put(
    'values/sync',
    params
  ).then(
    () => {}
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const importValues = (context, params) => {
    client.post(
        'values/import',
        params
    ).then(
        () => {}
    ).catch(
        err => console.error(err)
    )
}

const reloadDefaults = (context, dossierNr) => {
  context.commit('TOGGLE_RELOADING')

  client.get(`values/reload/${dossierNr}`).then(
    () => {
      context.commit('TOGGLE_RELOADING')
      context.dispatch('loadQuestions', { nr: dossierNr, admin: true })
    }
  ).catch(
    err => console.error(err)
  )
}

export default {
  save,
  load,
  copy,
  sync,
  create,
  remove,
  loadAll,
  importValues,
  loadQuestions,
  reloadDefaults
}
